import { createCompoundComponent } from '../../../utilities'
import { FadeInOutProvider as BaseFadeInOut } from './FadeInOutProvider'
import { Initial } from './Initial'
import { Animate } from './Animate'

export const FadeInOut = createCompoundComponent(BaseFadeInOut, {
  Initial,
  Animate,
})
